import React from 'react'
import { Outlet } from 'react-router-dom'

// Wrapper for all "Order management" (restaurant) sub-routes. AdminLayout already
// provides the page container + header, so this just renders the nested route.
function RestaurantModule() {
  return <Outlet />
}

export default RestaurantModule
